const addTogglePrevNextBtnsActiveGallery = (emblaApi, prevBtn, nextBtn) => {
  const togglePrevNextBtnsState = () => {
    if (emblaApi.canScrollPrev()) prevBtn.removeAttribute("disabled");
    else prevBtn.setAttribute("disabled", "disabled");

    if (emblaApi.canScrollNext()) nextBtn.removeAttribute("disabled");
    else nextBtn.setAttribute("disabled", "disabled");
  };

  emblaApi
    .on("select", togglePrevNextBtnsState)
    .on("init", togglePrevNextBtnsState)
    .on("reInit", togglePrevNextBtnsState);

  return () => {
    prevBtn.removeAttribute("disabled");
    nextBtn.removeAttribute("disabled");
  };
};

const addPrevNextBtnsClickHandlersGallery = (emblaApi, prevBtn, nextBtn) => {
  const scrollPrev = () => {
    emblaApi.scrollPrev();
  };
  const scrollNext = () => {
    emblaApi.scrollNext();
  };

  if (prevBtn && nextBtn) {
    // console.log(
    //   "Adding click handlers to prev and next buttons",
    //   prevBtn,
    //   nextBtn
    // );
    prevBtn.addEventListener("click", scrollPrev, false);
    nextBtn.addEventListener("click", scrollNext, false);

    const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActiveGallery(
      emblaApi,
      prevBtn,
      nextBtn
    );
  }

  return () => {
    removeTogglePrevNextBtnsActive();
    prevBtn.removeEventListener("click", scrollPrev, false);
    nextBtn.removeEventListener("click", scrollNext, false);
  };
};

// Grab wrapper nodes
var emblaNodes = document.querySelectorAll(".embla-gallery-js");
var options = { align: "start", loop: false, watchDrag: true };

// Loop through all instances of embla
emblaNodes.forEach(function (emblaNode) {
  // Grab viewport node
  const viewportNode = emblaNode.querySelector(".embla-gallery__viewport");

  // Grab button nodes
  const prevBtnNode = emblaNode.querySelector(".embla__button--prev");
  const nextBtnNode = emblaNode.querySelector(".embla__button--next");

  // Initialize the carousel
  const emblaApi = EmblaCarousel(viewportNode, options);

  // Add click listeners
  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlersGallery(
    emblaApi,
    prevBtnNode,
    nextBtnNode
  );

  emblaApi.on("destroy", removePrevNextBtnsClickHandlers);
});
